import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import PlaygroundWrapper from './components/playground-wrapper';
import Draggable from 'react-draggable';
import CodeHighlight from './components/code-highlight';

const styles = `
  .__clipPath {
    display: grid;
    gap: 2em
  }

  @media (min-width: 45em) {
    .__clipPath {
      grid-template-columns: 1fr 1fr;
      gap: 1em;
    }
  }

  .__clipPath .action {
    display: grid;
    place-items: center;
    padding: 3rem;
  }

  .__clipPath .action .target {
    aspect-ratio: 1;
    width: 100px;
    position: relative;
    outline: 2px dashed var(--red-bright);
  }
  .__clipPath .action .preview {
    width: 100%;
    height: 100%;
    background: var(--red-dark);
  }

  .__clipPath .react-draggable {
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    background: var(--blue);
    border: 2px solid white;
    border-radius: 50%;
    box-shadow: 0 2px 3px #222;
    display: grid;
    place-items: center;
    font-size: 0.75rem;
    font-family: monospace;
    cursor: grab;
    z-index: 3;
  }
  .__clipPath .react-draggable.react-draggable-dragging {
    cursor: grabbing;
  }

`;

const OutOfBoundClipPath = () => {
  const [point1, setPoint1] = useState([-20, 20]);
  const [point2, setPoint2] = useState([20, -20]);
  const [point3, setPoint3] = useState([120, 80]);
  const [point4, setPoint4] = useState([80, 120]);

  const baseWidth = 100;

  const cssClipPath = `polygon(
    ${point1[0]}% ${point1[1]}%,
    ${point2[0]}% ${point2[1]}%,
    ${point3[0]}% ${point3[1]}%,
    ${point4[0]}% ${point4[1]}%
  )`;
  const previewCss = `.red-square {
  clip-path: ${cssClipPath};
};`;

  const boundaryDistance = 80;

  return (
    <PlaygroundWrapper>
      <div className="__clipPath">
        <div className="action">
          <div
            className="target"
            style={{
              width: `${baseWidth}px`,
            }}
          >
            <Draggable
              axis="both"
              defaultPosition={{
                x: (baseWidth * point1[0]) / 100 - 15,
                y: (baseWidth * point1[1]) / 100 - 15,
              }}
              onDrag={(e, { x, y }) => {
                if (
                  x < -boundaryDistance ||
                  x > baseWidth - 30 + boundaryDistance
                )
                  return false;
                if (
                  y < -boundaryDistance ||
                  y > baseWidth - 30 + boundaryDistance
                )
                  return false;

                setPoint1([
                  Math.floor(((x + 15) / baseWidth) * 100),
                  Math.floor(((y + 15) / baseWidth) * 100),
                ]);
              }}
            >
              <span>1</span>
            </Draggable>
            <Draggable
              axis="both"
              defaultPosition={{
                x: (baseWidth * point2[0]) / 100 - 15,
                y: (baseWidth * point2[1]) / 100 - 15,
              }}
              onDrag={(e, { x, y }) => {
                if (
                  x < -boundaryDistance ||
                  x > baseWidth - 30 + boundaryDistance
                )
                  return false;
                if (
                  y < -boundaryDistance ||
                  y > baseWidth - 30 + boundaryDistance
                )
                  return false;

                setPoint2([
                  Math.floor(((x + 15) / baseWidth) * 100),
                  Math.floor(((y + 15) / baseWidth) * 100),
                ]);
              }}
            >
              <span>2</span>
            </Draggable>
            <Draggable
              axis="both"
              defaultPosition={{
                x: (baseWidth * point3[0]) / 100 - 15,
                y: (baseWidth * point3[1]) / 100 - 15,
              }}
              onDrag={(e, { x, y }) => {
                if (
                  x < -boundaryDistance ||
                  x > baseWidth - 30 + boundaryDistance
                )
                  return false;
                if (
                  y < -boundaryDistance ||
                  y > baseWidth - 30 + boundaryDistance
                )
                  return false;

                setPoint3([
                  Math.floor(((x + 15) / baseWidth) * 100),
                  Math.floor(((y + 15) / baseWidth) * 100),
                ]);
              }}
            >
              <span>3</span>
            </Draggable>
            <Draggable
              axis="both"
              defaultPosition={{
                x: (baseWidth * point4[0]) / 100 - 15,
                y: (baseWidth * point4[1]) / 100 - 15,
              }}
              onDrag={(e, { x, y }) => {
                if (
                  x < -boundaryDistance ||
                  x > baseWidth - 30 + boundaryDistance
                )
                  return false;
                if (
                  y < -boundaryDistance ||
                  y > baseWidth - 30 + boundaryDistance
                )
                  return false;

                setPoint4([
                  Math.floor(((x + 15) / baseWidth) * 100),
                  Math.floor(((y + 15) / baseWidth) * 100),
                ]);
              }}
            >
              <span>4</span>
            </Draggable>
            <div
              className="preview"
              style={{
                clipPath: cssClipPath,
              }}
            ></div>
          </div>
        </div>
        <CodeHighlight
          code={previewCss}
          language="css"
          style={{ margin: 0 }}
        ></CodeHighlight>
      </div>
    </PlaygroundWrapper>
  );
};

const renderComponent = (props, container) => {
  const root = createRoot(container);
  root.render(React.createElement(OutOfBoundClipPath, props));
};

export { renderComponent, styles };
export default OutOfBoundClipPath;
